module.exports = __webpack_public_path__ + "img/sq5d_feature_01.fb105a9c.jpg";